import { ActionButton } from "../../../shared/react/src/content/components/Button"

interface AssignAssetsButtonProps {
  onClick: () => void
}

/**
 * "Assign assets" entry point — always available regardless of the layout
 * lock (isEditMode). Assignment is a distinct workflow from layout editing,
 * so this button is never hidden by the lock/unlock toggle.
 */
const AssignAssetsButton = ({ onClick }: AssignAssetsButtonProps) => {
  return (
    <ActionButton
      context={{
        label: "Add assets",
        description: "Select assets to add to this system",
        variant: "primary",
      }}
      aria-label="Add assets"
      size="sm"
      onClick={onClick}
    />
  )
}

export default AssignAssetsButton
